import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CloseIcon from "@mui/icons-material/Close";
import job from "../../../assets/img/mark-job.svg";
import SettingsIcon from "@mui/icons-material/Settings";
import simpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import { showToast } from "../../../Helper/Toast";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader/Loader"; // adjust the path
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { hitUpdateProfileProfessionalApi } from "../../../Redux/Professional/UpdateProfileProfessionalSlice";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import { hitGetServiceProfessionalApi } from "../../../Redux/Professional/GetServiceSlice";
import AdditionalVerification from "../../../assets/img/Additional Verification.svg";
import ContractorLicenseVerification from "../../../assets/img/Contractor License Verification.svg";
import BusinessVerification from "../../../assets/img/Business Verification.svg";
import ProPlanIcon from "../../../assets/img/Pro Plan icon.svg";
import greentick from "../../../assets/img/green tick.svg";
import saveChange from "../../../assets/img/Save Changes.svg";
import CheckmarkIcon from "../../../assets/img/active tick.svg";
import location from "../../../assets/img/location jobs.svg";

const EditProfile = () => {
  const [radius, setRadius] = useState(45);
  const minRadius = 5;
  const maxRadius = 100;

  // Inject styles once on mount
  useEffect(() => {
    const styleId = "service-area-styles";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      // style.textContent = sassStyles;
      document.head.appendChild(style);
    }
  }, []);

  const handleSliderChange = (e) => {
    setRadius(parseInt(e.target.value));
  };

  const today = new Date();
  const eighteenYearsAgo = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  )
    .toISOString()
    .split("T")[0];

  const sliderPercentage =
    ((radius - minRadius) / (maxRadius - minRadius)) * 100;

  const navigation = useNavigate();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [professionalData, setProfessionalData] = useState(null);
  const [licenseNumber, setLicenseNumber] = useState("111111111111");
  const [isVerified, setIsVerified] = useState(true);

  const [contractorVerificationStep, setContractorVerificationStep] =
    useState(0);
  const [
    contractorLicenseVerificationStatus,
    setContractorLicenseVerificationStatus,
  ] = useState(0);

  const [businessVerificationStep, setBusinessVerificationStep] = useState(0);
  const [
    businessLicenseVerificationStatus,
    setBusinessLicenseVerificationStatus,
  ] = useState(0);

  const [contractorVerification, setContractorVerification] = useState({
    email: "",
    licenseNumber: "",
    issueState: "",
    legalName: "",
    businessName: "",
  });

  const [businessVerification, setBusinessVerification] = useState({
    email: "",
    documents: "",
  });

  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [legalName, setLegalName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [file, setFile] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [companyPosition, setCompanyPosition] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [serviceRadius, setServiceRadius] = useState("");
  const [yearsInBusiness, setYearsInBusiness] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("1");
  const [fullNumber, setFullNumber] = useState("");
  const [search, setSearchTerm] = useState("");
  const [allServices, setAllServices] = useState([]);

  const [businessDocument, setBusinessDocument] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  const fetchServices = async (search = "") => {
    try {
      const response = await dispatch(hitGetServiceProfessionalApi(search));
      setAllServices(response.payload.data);
      // Handle the response as needed
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  useEffect(() => {
    if (search === "") {
      fetchServices(); // call API again with no search
    }
  }, [search]);

  const filteredServices = allServices.filter((service) =>
    service.name.toLowerCase().includes(search.toLowerCase()),
  );

  const handleOnChange = (value, data) => {
    // value = full phone number (e.g. "919876543210")
    // data.dialCode = country code (e.g. "91")
    setFullNumber(value);
    setCountryCode("+" + data.dialCode);
    // Remove country code from value
    const numberWithoutCode = value.replace(data.dialCode, "");
    setMobileNumber(numberWithoutCode);
  };

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      fetchServices();
      dispatch(hitGetProfileApi());
    }
  }, []);

  // Redux state
  const responseProfileProfessional = useSelector(
    (state) => state.getProfileProfessionalReducer.data,
  );

  useEffect(() => {
    if (responseProfileProfessional?.status === true) {
      setLoading(false);
      setProfessionalData(responseProfileProfessional.data);
      setFirstName(responseProfileProfessional.data.firstName || "");
      setLastName(responseProfileProfessional.data.lastName || "");
      setZipCode(responseProfileProfessional.data.zipCode || "");
      setCompanyPosition(
        responseProfileProfessional.data.companyPosition || "",
      );
      setCompanyName(responseProfileProfessional.data.companyName || "");
      setEmail(responseProfileProfessional.data.email || "");
      setServiceRadius(responseProfileProfessional.data.serviceDistance || "");
      setYearsInBusiness(
        responseProfileProfessional.data.yearsInBusiness || "",
      );
      setWebsiteURL(responseProfileProfessional.data.websiteURL || "");
      setCountryCode(responseProfileProfessional.data.countryCode || "");
      setMobileNumber(responseProfileProfessional.data.mobileNumber || "");

      setDateOfBirth(
        responseProfileProfessional.data.dateOfBirth
          ? moment(responseProfileProfessional.data.dateOfBirth).format(
            "MM/DD/YYYY"
          )
          : ""
      );
      setGender(responseProfileProfessional.data.gender || "1");
      setCountryCode("+" + responseProfileProfessional.data.countryCode);
      setFullNumber(
        responseProfileProfessional.data.countryCode +
          responseProfileProfessional.data.mobileNumber,
      );
      setMobileNumber(responseProfileProfessional.data.mobileNumber || "");

      setBusinessLicenseVerificationStatus(
        responseProfileProfessional.data.isBusinessVerified,
      );

      setContractorLicenseVerificationStatus(
        responseProfileProfessional.data.isContractorLicenseVerified,
      );
      if (responseProfileProfessional.data.isContractorLicenseVerified !== 0) {
        setContractorVerification({
          email:
            responseProfileProfessional.data.contractorLicenseVerificationData
              .email || "",
          licenseNumber:
            responseProfileProfessional.data.contractorLicenseVerificationData
              .licenseNumber || "",
          issueState:
            responseProfileProfessional.data.contractorLicenseVerificationData
              .issueState || "",
          legalName:
            responseProfileProfessional.data.contractorLicenseVerificationData
              .legalName || "",
          businessName:
            responseProfileProfessional.data.contractorLicenseVerificationData
              .businessName || "",
        });
      }
      //isContractorLicenseVerified: { type: Number, default: 0 }, // 0 - pending, 1- submitted, 2 - verified, 3 - rejected
      if (contractorLicenseVerificationStatus === 1) {
        setContractorVerificationStep(3);
      }

      if (responseProfileProfessional.data.isBusinessVerified !== 0) {
        setBusinessVerification({
          email:
            responseProfileProfessional.data.businessVerificationData.email ||
            "",
          documents:
            responseProfileProfessional.data.businessVerificationData
              .documents || "",
        });
      }
      if (businessLicenseVerificationStatus === 1) {
        setBusinessVerificationStep(3);
      }
    }
  }, [responseProfileProfessional]);

  const handleSaveChanges = () => {
    const formData = {
      firstName,
      lastName,
      zipCode,
      companyPosition,
      companyName,
      email,
      serviceDistance: serviceRadius,
      yearsInBusiness,
      website: websiteURL,
      countryCode,
      mobileNumber,
      dateOfBirth,
      gender,
      fullNumber,
      serviceIds: professionalData.serviceIds.map((s) => s._id),
    };
    dispatch(hitUpdateProfileProfessionalApi(formData)).then((response) => {
      if (response.payload.status === true) {
        showToast("Profile updated successfully!", "success");
        navigate("/professional/profile");
      }
    });
  };

  const updateContractorLicense = (step) => {
    //console.log("calling update contractor license api", step);
    setContractorVerificationStep(step);
    if (step === 3) {
      dispatch(
        hitUpdateProfileProfessionalApi({
          contractorLicenseVerificationData: contractorVerification,
        }),
      ).then((response) => {
        if (response.payload.status === true) {
          showToast("Contractor license verification submitted!", "success");
          dispatch(hitGetProfileApi());
        }
      });
    }
  };

  const updateBusinessVerification = (step) => {
    setBusinessVerificationStep(step);
    if (step === 3) {
      if (!businessDocument) {
        showToast("Please upload business document!", "error");
        return;
      }
      dispatch(
        hitUpdateProfileProfessionalApi({
          businessVerificationData: businessVerification,
        }),
      ).then((response) => {
        if (response.payload.status === true) {
          showToast("Business verification submitted!", "success");
          dispatch(hitGetProfileApi());
        }
      });
    }
  };

  // Handle file selection
  const handleFileChange = (event) => {
    //console.log("handleFileChange calling");
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    // Create a preview URL for the selected image
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setImageUrl(previewUrl);
    }
  };

  // UseEffect to trigger upload when `file` changes
  useEffect(() => {
    if (file) {
      //console.log("file handl starts", file);
      uploadFile();
    }
  }, [file]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    if (file) {
      //console.log("myfile", file);
      const formData = new FormData();
      formData.append("myfile", file);
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          setBusinessDocument(response.payload.data[0].url);
          setBusinessVerification({
            ...businessVerification,
            documents: [response.payload.data[0].url],
          });
          showToast("File uploaded successfully!", "success");
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };

  const handleRemoveService = (serviceId) => {
    const updatedServices = professionalData.serviceIds.filter(
      (service) => service._id !== serviceId,
    );
    setProfessionalData({ ...professionalData, serviceIds: updatedServices });
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <div style={{ height: "100vh" }}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="pro-app-page pro-app-page--muted pro-edit-profile">
      <div className="custom_container pro-edit-profile__container">
        <div className="pro-edit-profile__toolbar edit_profile">
          <div className="edit_profile_head">
            <div className="profile_information">
              <h4>Edit Profile</h4>
              <p>Update your professional information</p>
            </div>
            <div className="btn_flex">
              <Button
                className="cancel_btn"
                onClick={() => {
                  handleViewDetails();
                  navigate("/professional/profile");
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleSaveChanges}>
                <img src={saveChange} alt="" />
                Save Changes
              </Button>
            </div>
          </div>
        </div>

        {professionalData && (
          <div className="pro-edit-profile__layout">
            <div className="pro-edit-profile__main">
              <div className="profile-form">
                  {/* Form */}
                  <form>
                    <div className="form-grid-2">
                      <div className="form-header">
                        <div className="logo">
                          {" "}
                          {professionalData.companyName
                            .split(" ")
                            .map((word, i) => (
                              <span key={i} className="block">
                                {word}
                              </span>
                            ))}
                        </div>
                        <h2>Profile Information</h2>
                        <p>Keep your professional details up to date</p>
                      </div>
                      <div className="form-grid">
                        <div className="form-group">
                          <label>
                            First name{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={firstName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const capitalized =
                                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
                              setFirstName(capitalized);
                            }}
                            placeholder="Joe"
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Last name{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={lastName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const capitalized =
                                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
                              setLastName(capitalized);
                            }}
                            placeholder="Rogers"
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Zip code <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={zipCode}
                            onChange={(e) => setZipCode(e.target.value)}
                            placeholder="85210"
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Company position{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={companyPosition}
                            onChange={(e) => setCompanyPosition(e.target.value)}
                            placeholder="Sales Representative"
                          />
                        </div>
                        <div className="form-group full">
                          <label>
                            Company name{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="text"
                            value={companyName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const capitalized =
                                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
                              setCompanyName(capitalized);
                            }}
                            placeholder="Always Green Turf AZ"
                          />
                        </div>
                        <div className="form-group full">
                          <label>
                            Professional field{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>

                          {/* Selected Tags */}
                          <div className="tags">
                            {professionalData.serviceIds &&
                              professionalData.serviceIds.map(
                                (service, index) => (
                                  <span key={service._id}>
                                    {service.name}
                                    <CloseIcon
                                      onClick={() =>
                                        handleRemoveService(service._id)
                                      }
                                      style={{
                                        marginLeft: 4,
                                        fontSize: 20,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                ),
                              )}
                          </div>

                          {/* Search Input */}
                          <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search or add professional fields..."
                          />

                          {/* Dropdown */}
                          {search && (
                            <ul className="dropdowns">
                              {filteredServices.length > 0 ? (
                                filteredServices.map((service) => (
                                  <li
                                    key={service._id}
                                    onClick={() => {
                                      if (
                                        !professionalData.serviceIds.some(
                                          (s) => s._id === service._id,
                                        )
                                      ) {
                                        setProfessionalData({
                                          ...professionalData,
                                          serviceIds: [
                                            ...professionalData.serviceIds,
                                            service,
                                          ],
                                        });
                                      }
                                      setSearchTerm(""); // clear after selection
                                    }}
                                  >
                                    {service.name}
                                  </li>
                                ))
                              ) : (
                                <li>No results found</li>
                              )}
                            </ul>
                          )}
                        </div>

                        <div className="form-group">
                          <label>
                            Years in business{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="number"
                            value={yearsInBusiness}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value <= 50) {
                                setYearsInBusiness(value);
                              } else {
                                setYearsInBusiness(100); // optional: auto-limit to 100
                              }
                            }}
                            placeholder="5"
                            max="100"
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Service radius{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <div className="inline">
                            <input
                              type="number"
                              value={serviceRadius}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value <= 50) {
                                  setServiceRadius(value);
                                } else {
                                  setServiceRadius(50); // optional: auto-limit to 50
                                }
                              }}
                              placeholder="45"
                              max="50"
                            />
                            <span>miles</span>
                          </div>
                        </div>
                        <div className="form-group full">
                          <label>Website URL</label>
                          <input
                            type="text"
                            value={websiteURL}
                            onChange={(e) => setWebsiteURL(e.target.value)}
                            placeholder="www.alwaysgreenturf.com"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Contact Information */}
                    <div className="form-grid-2">
                      <h3 className="section-title">Contact Information</h3>
                      <div className="form-grid">
                        <div className="form-group">
                          <label>
                            Mobile number{" "}
                            <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <PhoneInput
                            country={"in"} // default India
                            value={fullNumber}
                            onChange={handleOnChange}
                            inputStyle={{ width: "100%" }}
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Email <span style={{ color: "#b73534" }}>*</span>
                          </label>
                          <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="joe@alwaysgreenturf.com"
                          />
                        </div>
                        <div className="form-group">
                          <label>Date of Birth</label>
                          <input
                            type="date"
                            value={dateOfBirth}
                            onChange={(e) => setDateOfBirth(e.target.value)}
                            placeholder="MM/DD/YYYY"
                            max={eighteenYearsAgo} // 👈 users cannot pick 2009 or later
                          />
                        </div>
                        <div className="form-group">
                          <label>Gender</label>
                          <select
                            className="filter-select"
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                          >
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="3">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="form-grid-2">
                      <div className="license-info">
                        <h3 className="section-title">License Information</h3>

                        {/* Top Section */}
                        <div className="form-section">
                          <label className="checkbox-label">
                            <input type="checkbox" checked readOnly />
                            Licensed, bonded, and insured?
                          </label>

                          <div className="input-group">
                            <label htmlFor="licenseNumber">
                              License Number
                            </label>
                            <input
                              type="text"
                              id="licenseNumber"
                              value={licenseNumber}
                              onChange={(e) => setLicenseNumber(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Verification Section */}
                        {isVerified && (
                          <div className="verification-box">
                            <div className="status">
                              <span className="checkmark">
                                <img src={greentick} alt="green tick" />
                              </span>
                              <h4>Verification Complete</h4>
                            </div>
                            <p>
                              Your professional license has been successfully
                              verified and is now active on your profile.
                            </p>

                            <div className="details">
                              <div className="detail_info">
                                <span>Email Address:</span>
                                <span className="strong">
                                  {" "}
                                  joe@alwaysgreenturf.com
                                </span>
                              </div>
                              <div className="detail_info">
                                <span>Document Type:</span>
                                <span className="strong">
                                  {" "}
                                  Professional License
                                </span>
                              </div>
                              <div className="detail_info">
                                <span>Verified At:</span>
                                <span className="strong">
                                  {" "}
                                  23/09/2025, 03:24:16
                                </span>
                              </div>
                              <div className="detail_info">
                                <span>Reference:</span>
                                <span className="strong"> VER-QZ13LM6A8</span>
                              </div>
                            </div>

                            {/* <div className="actions">
                              <button className="btn-outline">
                                View Certificate
                              </button>
                              <button className="btn-primary">
                                Download Proof
                              </button>
                            </div> */}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
              </div>
            </div>

            <div className="pro-edit-profile__sidebar">
              <div className="service-area-container">
                  <div className="plan-header">
                    <div className="d-flex justify-content-between w-100">
                      <div>
                        <span className="plan-name">Pro Plan</span>
                        <br />
                        <span className="plan-description">
                          Maximize your reach
                        </span>
                      </div>
                      <img src={ProPlanIcon} alt="Pro Plan icon" />
                    </div>
                  </div>

                  {/* <div className="service-area-box">
                    <h3>Service Area</h3>
                    <p className="location">Phoenix, AZ</p>
                    <div className="radius-circle">
                      <div className="circle"></div>
                    </div>
                    <p className="circle-label">45 miles radius</p>

                    <p className="coverage-info">
                      Coverage area surrounding your business location
                    </p>
                    <p className="radius-distance">45 miles</p>
                    <p className="additional-info">
                      Expand your service area coverage for just $5/month per
                      additional area.
                    </p>
                    <button className="add-area-btn">
                      Add more Service Area
                    </button>
                  </div> */}

                  <div className="service-area-container-2">
                    <div className="service-area-card">
                      <div className="header">
                        <img
                          src={location}
                          alt="location"
                          style={{ width: "18px", height: "18px" }}
                        />
                        <h2>Service Area</h2>
                      </div>

                      <div className="slider-section">
                        <div className="slider-header">
                          <span className="label">Service Radius</span>
                          <span className="value">{radius} miles</span>
                        </div>

                        <div className="slider-container">
                          <input
                            type="range"
                            min={minRadius}
                            max={maxRadius}
                            value={radius}
                            onChange={handleSliderChange}
                            className="slider"
                            style={{
                              background: `linear-gradient(to right, #dc2626 0%, #dc2626 ${sliderPercentage}%, #e5e7eb ${sliderPercentage}%, #e5e7eb 100%)`,
                            }}
                          />
                        </div>

                        <div className="slider-labels">
                          <span>{minRadius} miles</span>
                          <span>{maxRadius} miles</span>
                        </div>
                      </div>

                      <div className="map-section">
                        <div className="location-tag">
                          <img
                            src={location}
                            alt="location"
                            style={{ width: "12px", height: "12px" }}
                          />
                          <span>Phoenix, AZ</span>
                        </div>

                        <div className="map">
                          <div
                            className="radius-circle"
                            style={{
                              width: `${Math.min(radius * 2, 160)}px`,
                              height: `${Math.min(radius * 2, 160)}px`,
                            }}
                          >
                            <div className="center-dot"></div>
                          </div>
                        </div>

                        <div className="radius-label">
                          <strong>{radius} miles</strong> radius
                        </div>
                      </div>

                      <div className="footer">
                        <p className="description">
                          Area surrounding your business location
                        </p>
                        <p className="radius-info">
                          <strong>{radius} miles</strong>
                        </p>
                        <p className="pricing">
                          Expand your service area coverage for just $9/month
                          <br />
                          per additional areas.{" "}
                          <a href="#" className="link">
                            Add more services area.
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="quick-actions">
                    <h4>Quick Actions</h4>
                    <button
                      className="account-settings-btn"
                      onClick={() => {
                        handleViewDetails();
                        navigate("/professional/settings");
                      }}
                    >
                      <SettingsIcon /> Account Settings
                    </button>
                  </div>

                  <div className="pro-plan-card">
                    <div className="header">
                      <h3>Monthly Pro Plan</h3>
                      <span className="status">
                        <span className="checkmark">
                          <img src={CheckmarkIcon} alt="Checkmark" />
                        </span>{" "}
                        ACTIVE
                      </span>
                    </div>

                    <div className="price">
                      <span className="amount">$149</span>
                      <span className="per">
                        <strong>/mo</strong>
                      </span>
                    </div>

                    <ul className="features">
                      <li>
                        <span className="dot">●</span> 100 bid credits per month
                      </li>
                      <li>
                        <span className="dot">●</span> Top-listed Pro visibility
                      </li>
                      <li>
                        <span className="dot">●</span> Exclusive promotions
                      </li>
                      <li>
                        <span className="dot">●</span> Full client insights
                      </li>
                      <li>
                        <span className="dot">●</span> Bid credit protection
                      </li>
                      <li>
                        <span className="dot">●</span> Import reviews
                      </li>
                    </ul>
                  </div>

                  <div className="pro-plan-card pro-plan-card-2">
                    <div className="header">
                      <h3>Annual Pro Plan</h3>
                      <span className="status">UPGRADE</span>
                    </div>

                    <div className="price">
                      <span className="amount">$149</span>
                      <span className="per">
                        <strong>/mo</strong>
                      </span>
                    </div>

                    <div className="white_card_sec">
                      <span>
                        <strong>Annual Plan Bonus:</strong>
                      </span>
                      <p>
                        Save $439 annually (3 months free + 300 bonus credits
                      </p>
                    </div>

                    <ul className="features">
                      <li>
                        <span className="dot">●</span> 100 bid credits per month
                      </li>
                      <li>
                        <span className="dot">●</span> Top-listed Pro visibility
                      </li>
                      <li>
                        <span className="dot">●</span> Exclusive promotions
                      </li>
                      <li>
                        <span className="dot">●</span> Full client insights
                      </li>
                      <li>
                        <span className="dot">●</span> Bid credit protection
                      </li>
                      <li>
                        <span className="dot">●</span> Import reviews
                      </li>
                    </ul>
                  </div>

                  <div className="verification-container">
                    <div className="additional_verify">
                      <img
                        src={AdditionalVerification}
                        alt="Additional Verification"
                      />
                      <div>
                        <h2 className="section-title">
                          Additional Verification
                        </h2>
                        <p className="section-description">
                          Optional verifications to build trust with homeowners
                        </p>
                      </div>
                    </div>

                    <div className="verification-card">
                      <div className="verification-header">
                        <img
                          src={ContractorLicenseVerification}
                          alt="Contractor License Verification"
                        />
                        <div>
                          <h3 className="verification-title">
                            Contractor License Verification
                          </h3>
                          <p className="verification-description">
                            Manual check against U.S. state license databases.
                            Shows you are a licensed trade professional.
                          </p>
                        </div>
                        <span className="verification-status">Optional</span>
                      </div>

                      <button
                        className="verify-button"
                        onClick={() => setContractorVerificationStep(1)}
                        disabled={
                          contractorLicenseVerificationStatus !== 0 &&
                          contractorLicenseVerificationStatus !== 3
                        }
                      >
                        {contractorLicenseVerificationStatus === 0
                          ? "Verify Contractor License"
                          : contractorLicenseVerificationStatus === 2
                            ? "Contractor License Verified"
                            : contractorLicenseVerificationStatus === 3
                              ? "Contractor License Verification Failed"
                              : "Contractor License Verification In Progress"}
                      </button>
                    </div>

                    {contractorVerificationStep === 1 && (
                      <div className="email-step-container">
                        <div className="stepper">
                          <div className="step active">1</div>
                          <div className="line" />
                          <div className="step">2</div>
                          <div className="line" />
                          <div className="step">3</div>
                        </div>

                        <h2 className="main-title">Start with your Email</h2>
                        <p className="subtitle">
                          Confirm your work email address
                        </p>

                        <label className="input-label">Email Address</label>
                        <input
                          type="email"
                          value={contractorVerification.email}
                          onChange={(e) =>
                            setContractorVerification({
                              ...contractorVerification,
                              email: e.target.value,
                            })
                          }
                          className="email-input"
                          placeholder="you@example.com"
                        />

                        <p className="note">
                          This email will be used by{" "}
                          <span className="brand">SimpleRenovate</span> to
                          communicate updates about your verification and to
                          help you maintain Verified status.
                        </p>

                        <div className="footer">
                          <div className="powered-by">
                            <span>Verification Powered by</span>
                            <img
                              src={simpleRenovate}
                              alt="SimpleRenovate Logo"
                              className="logo"
                            />
                          </div>
                          <button
                            className="next-btn"
                            onClick={() => updateContractorLicense(2)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}

                    {contractorVerificationStep === 2 && (
                      <div className="license-step-container">
                        <div className="stepper">
                          <div className="step completed">1</div>
                          <div className="line" />
                          <div className="step active">2</div>
                          <div className="line" />
                          <div className="step">3</div>
                        </div>

                        <h2 className="title">Professional License</h2>
                        <p className="subtitle">
                          Provide your license details exactly as they appear on
                          your government-issued license.
                        </p>

                        <label>
                          License Number
                          <span style={{ color: "#b73534" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={contractorVerification.licenseNumber}
                          onChange={(e) =>
                            setContractorVerification({
                              ...contractorVerification,
                              licenseNumber: e.target.value,
                            })
                          }
                          placeholder="A234586764G7"
                        />

                        <label>
                          Issuing State
                          <span style={{ color: "#b73534" }}>*</span>
                        </label>
                        <select
                          className="filter-select"
                          value={contractorVerification.state}
                          onChange={(e) =>
                            setContractorVerification({
                              ...contractorVerification,
                              state: e.target.value,
                            })
                          }
                        >
                          <option value="">Select State</option>
                          <option value="AZ">Arizona</option>
                          <option value="CA">California</option>
                          <option value="TX">Texas</option>
                        </select>

                        <label>
                          Legal Name<span style={{ color: "#b73534" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={contractorVerification.legalName}
                          onChange={(e) =>
                            setContractorVerification({
                              ...contractorVerification,
                              legalName: e.target.value,
                            })
                          }
                          placeholder="Ryan Smith"
                        />

                        <label>
                          Business Name
                          <span style={{ color: "#b73534" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={contractorVerification.businessName}
                          onChange={(e) =>
                            setContractorVerification({
                              ...contractorVerification,
                              businessName: e.target.value,
                            })
                          }
                          placeholder="Always Green Turf AZ"
                        />

                        {/* <div className="upload-box">
                        <div className="upload-icon">📄</div>
                        <p>Upload your license document</p>
                        <span>Drag and drop or click to browse</span>
                        <br />
                        <label className="choose-file-btn">
                          Choose File
                          <input
                            type="file"
                            onChange={handleFileChange}
                            hidden
                          />
                        </label>
                      </div>
                      <p className="file-info">
                        Accepted formats: PDF, JPG, PNG (Max 10MB)
                      </p> */}

                        <div className="footer">
                          <div className="powered-by">
                            <span>Verification Powered by</span>
                            <img
                              src={simpleRenovate}
                              alt="SimpleRenovate Logo"
                              className="logo"
                            />
                          </div>
                          <button
                            className="next-btn"
                            onClick={() => updateContractorLicense(3)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                    {contractorVerificationStep === 3 && (
                      <div className="verification-complete-container">
                        <div className="stepper">
                          <div className="step completed">1</div>
                          <div className="line" />
                          <div className="step completed">2</div>
                          <div className="line" />
                          <div className="step active">3</div>
                        </div>

                        <div className="thank-you-box">
                          <div className="check-icon">✔</div>
                          <h2>Thank You!</h2>
                          <p>
                            We will email your verification results within 3
                            business days.
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="verification-card">
                      <div className="verification-header">
                        <img
                          src={BusinessVerification}
                          alt="Business Verification"
                        />
                        <div>
                          <h3 className="verification-title">
                            Business Verification
                          </h3>
                          <p className="verification-description">
                            Document upload verification to confirm you are a
                            real, registered business.
                          </p>
                        </div>
                        <span className="verification-status">Optional</span>
                      </div>

                      <button
                        className="verify-button"
                        onClick={() => setBusinessVerificationStep(1)}
                        disabled={
                          businessLicenseVerificationStatus !== 0 &&
                          businessLicenseVerificationStatus !== 3
                        }
                      >
                        {businessLicenseVerificationStatus === 0
                          ? "Verify Business License"
                          : businessLicenseVerificationStatus === 2
                            ? "Business License Verified"
                            : businessLicenseVerificationStatus === 3
                              ? "Business License Verification Failed"
                              : "Business License Verification In Progress"}
                      </button>
                    </div>

                    {businessVerificationStep === 1 && (
                      <div className="email-step-container email-step-container-2">
                        <div className="stepper">
                          <div className="step active">1</div>
                          <div className="line" />
                          <div className="step">2</div>
                          <div className="line" />
                          <div className="step">3</div>
                        </div>

                        <h2 className="main-title">Start with your Email</h2>
                        <p className="subtitle">
                          Confirm your work email address
                        </p>

                        <label className="input-label">Email Address</label>
                        <input
                          type="email"
                          value={businessVerification.email}
                          onChange={(e) =>
                            setBusinessVerification({
                              ...businessVerification,
                              email: e.target.value,
                            })
                          }
                          className="email-input"
                          placeholder="you@example.com"
                        />

                        <p className="note">
                          This email will be used by{" "}
                          <span className="brand">SimpleRenovate</span> to
                          communicate updates about your verification and to
                          help you maintain Verified status.
                        </p>

                        <div className="footer">
                          <div className="powered-by">
                            <span>Verification Powered by</span>
                            <img
                              src={simpleRenovate}
                              alt="SimpleRenovate Logo"
                              className="logo"
                            />
                          </div>
                          <button
                            className="next-btn"
                            disabled={!businessVerification.email}
                            onClick={() => updateBusinessVerification(2)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}

                    {businessVerificationStep === 2 && (
                      <div className="license-step-container license-step-container-2">
                        <div className="stepper">
                          <div className="step completed">1</div>
                          <div className="line" />
                          <div className="step active">2</div>
                          <div className="line" />
                          <div className="step">3</div>
                        </div>

                        <h2 className="title">Upload Business Documnets</h2>
                        <p className="subtitle">
                          Upload one or more documnes that prove your business
                          registration
                        </p>

                        <div className="upload-box">
                          <div className="upload-icon">📄</div>
                          <p>Upload Documnets</p>
                          <span>Drag and drop or click to browse</span>
                          <br />
                          {businessDocument && (
                            <p className="uploaded-file">
                              <img
                                src={businessDocument}
                                alt="Uploaded Document"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            </p>
                          )}
                          ;
                          <label className="choose-file-btn">
                            Choose File
                            <input
                              type="file"
                              onChange={handleFileChange}
                              hidden
                            />
                          </label>
                        </div>
                        <p className="file-info">
                          Accepted formats: PDF, JPG, PNG (Max 10MB)
                        </p>

                        <div className="footer">
                          <div className="powered-by">
                            <span>Verification Powered by</span>
                            <img
                              src={simpleRenovate}
                              alt="SimpleRenovate Logo"
                              className="logo"
                            />
                          </div>
                          <button
                            className="next-btn"
                            disabled={!businessDocument}
                            onClick={() => updateBusinessVerification(3)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}

                    {businessVerificationStep === 3 && (
                      <div className="verification-complete-container verification-complete-container-2">
                        <div className="stepper">
                          <div className="step completed">1</div>
                          <div className="line" />
                          <div className="step completed">2</div>
                          <div className="line" />
                          <div className="step active">3</div>
                        </div>

                        <div className="thank-you-box">
                          <div className="check-icon">✔</div>
                          <h2>Thank You!</h2>
                          <p>
                            We will email your verification results within 3
                            business days.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditProfile;
